import { render } from "./BienImmoLocaprincModal.vue?vue&type=template&id=4bf44dd8"
import script from "./BienImmoLocaprincModal.ts?vue&type=script&lang=js"
export * from "./BienImmoLocaprincModal.ts?vue&type=script&lang=js"

import "./BienImmoLocaprincModal.vue?vue&type=style&index=0&id=4bf44dd8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__